import React, { useState, useMemo } from "react";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import CssBaseline  from "@mui/material/CssBaseline";
import ThemeContext  from "../ThemeContext";
import { darkTheme, lightTheme } from "../../../styles/theme";

// Key used to persist theme mode in localStorage
const THEME_STORAGE_KEY = "psi360_theme_mode";

const AppThemeProvider = ({ children }) => {

  const [mode, setMode] = useState(() => {
    // Read saved mode from localStorage on first load
    // Falls back to dark if nothing is saved yet
    const saved = localStorage.getItem(THEME_STORAGE_KEY);
    return saved === "light" || saved === "dark" ? saved : "dark";
  });

  const toggleMode = () => {
    setMode((prev) => {
      const next = prev === "dark" ? "light" : "dark";
      // Persist the new mode so it survives page reload
      localStorage.setItem(THEME_STORAGE_KEY, next);
      return next;
    });
  };

  // Recompute only when mode changes
  const muiTheme = useMemo(
    () => (mode === "dark" ? darkTheme : lightTheme),
    [mode]
  );

  return (
    <ThemeContext.Provider value={{ mode, toggleMode }}>
      <MuiThemeProvider theme={muiTheme}>
        {/* CssBaseline applies background and text colors globally */}
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
};

export default AppThemeProvider;